import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router';
import { qk } from '@immoaktas/api-client';
import { api } from '../lib/api';
import { ErrorState, Skeleton } from '../ui';

/**
 * Sidebar entries without an account-wide screen yet (Zähler, Chronik) open the matching screen of the
 * first property (/objekte/:id/zaehler|chronik); without properties they open the property list. Replace with the global screens
 * once they exist (design/Zaehler.dc.html, design/Chronik.dc.html).
 */
export default function ToFirstProperty({ tab }: { tab: 'zaehler' | 'chronik' }) {
  const q = useQuery({ queryKey: qk.properties, queryFn: () => api.properties.list() });
  if (q.isPending) return <Skeleton count={4} h={22} />;
  if (q.isError) return <ErrorState error={q.error} onRetry={() => void q.refetch()} retrying={q.isFetching} />;
  const first = q.data[0];
  return <Navigate to={first ? `/objekte/${first.id}/${tab}` : '/objekte'} replace />;
}
